module.exports = __webpack_public_path__ + "static/media/11.6ba85eaf.webp";